import { openWindowPopup } from '../common';

export const twitterShare = (url: string) => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${ url }`;
    openWindowPopup(twitterUrl, 'twitter', 500, 500);
};